export default {
  data () {
    return {
      addForm: {
      },
      addFromRules: {
        schoolName: [
          { required: true, message: '请输入学校名', trigger: 'blur' },
        ],
        stuId: [
          { required: true, message: '请输入学号', trigger: 'blur' },
        ],
        stuName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '密码长度在5-15长度之间', trigger: 'blur' }
        ]
      }
    }
  },

  created () {

  },
  methods: {
    // 初始化密码
    reset () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        //  通过校验，可以发起请求
        const { data: res } = await this.$http.post('/system/resetInitPassword', this.addForm)
        if (res.code !== 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('初始化密码成功')
        this.$refs.addFormRef.resetFields()
        // 添加完成隐藏对话框
      })
    },
  }
}
